<template>
  <section class="prod-hero">
    <div class="prod-hero__glow" />
    <div class="prod-hero__row">
      <div class="min-w-0">
        <p class="prod-kicker">{{ kicker }}</p>
        <div class="flex flex-wrap items-center gap-3">
          <h2 class="prod-hero__title">{{ title }}</h2>
          <slot name="badge" />
        </div>
        <p v-if="subtitle" class="prod-hero__sub">{{ subtitle }}</p>
      </div>
      <div v-if="$slots.actions" class="prod-hero__actions">
        <slot name="actions" />
      </div>
    </div>
    <slot />
  </section>
</template>

<script setup>
/* global defineProps */
defineProps({
  kicker: {
    type: String,
    default: 'Workspace'
  },
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  }
})
</script>
